"use client";

import { usePathname } from "next/navigation";
import { useId, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import GailAssistantLauncherButton from "@/components/chat/GailAssistantLauncherButton";
import GailAssistantSheet from "@/components/chat/GailAssistantSheet";
import { useGailDock } from "@/contexts/chat/GailDockContext";
import { useFloatingClearance } from "@/hooks/useFloatingClearance";
import { useGailGptChatAccess } from "@/hooks/useGailGptChatAccess";
import { shouldShowGailGptLauncher } from "@/utils/chat/gailGptLauncher";

function Launcher() {
  const { t } = useTranslation("ask");
  const [open, setOpen] = useState(false);
  const [conversationId, setConversationId] = useState<string | null>(null);
  const bottomOffset = useFloatingClearance(!open);
  const panelId = useId();
  const triggerRef = useRef<HTMLButtonElement>(null);
  return (
    <>
      <GailAssistantSheet
        id={panelId}
        triggerRef={triggerRef}
        open={open}
        onClose={() => setOpen(false)}
        conversationId={conversationId}
        onSelectConversation={setConversationId}
        onNewChat={() => setConversationId(null)}
      />
      <GailAssistantLauncherButton
        ref={triggerRef}
        aria-controls={panelId}
        aria-expanded={open}
        aria-hidden={open}
        data-open={open}
        inert={open}
        aria-label={t("launcher.open", { assistant: t("launcher.label") })}
        onClick={() => setOpen(true)}
        style={{ bottom: bottomOffset }}
        className={`fixed right-6 z-40 ${open ? "pointer-events-none" : ""}`}
      />
    </>
  );
}

/** Bottom-right launcher for pages without another assistant entry point. */
export default function GailGptLauncher() {
  const pathname = usePathname() ?? "";
  const { allowed } = useGailGptChatAccess();
  const { isDockAvailable } = useGailDock();
  if (!shouldShowGailGptLauncher(pathname, allowed, isDockAvailable)) return null;
  return <Launcher />;
}
